import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import '../assets/css/element-theme.scss'
import '../assets/css/element-reset.scss'
Vue.use(Element, {
    locale
})
